import {
  getDetail,
  deleteObj,
  searchByName,
  getAll,
  getPage,
  getMyCreatePage,
  wechatGenerateOrder,
  wechatPayCallback,
  getMyPayPage,
} from '@/api/allinpayorderserv'

export default {
  state: {
    state_AllInPayOrder_GetDetailResult: null,
    state_AllInPayOrder_DeleteObjResult: null,
    state_AllInPayOrder_SearchByNameResult: null,
    state_AllInPayOrder_GetAllResult: null,
    state_AllInPayOrder_GetPageResult: null,
    state_AllInPayOrder_GetMyCreatePageResult: null,
    state_AllInPayOrder_WechatGenerateOrderResult: null,
    state_AllInPayOrder_WechatPayCallbackResult: null,
    state_AllInPayOrder_GetMyPayPageResult: null,
  },
  mutations: {
    SET_ALLINPAYORDER_GETDETAIL_RESULT: (state, rst) => {
      state.state_AllInPayOrder_GetDetailResult = rst;
    },
    SET_ALLINPAYORDER_DELETEOBJ_RESULT: (state, rst) => {
      state.state_AllInPayOrder_DeleteObjResult = rst;
    },
    SET_ALLINPAYORDER_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_AllInPayOrder_SearchByNameResult = rst;
    },
    SET_ALLINPAYORDER_GETALL_RESULT: (state, rst) => {
      state.state_AllInPayOrder_GetAllResult = rst;
    },
    SET_ALLINPAYORDER_GETPAGE_RESULT: (state, rst) => {
      state.state_AllInPayOrder_GetPageResult = rst;
    },
    SET_ALLINPAYORDER_GETMYCREATEPAGE_RESULT: (state, rst) => {
      state.state_AllInPayOrder_GetMyCreatePageResult = rst;
    },
    SET_ALLINPAYORDER_WECHATGENERATEORDER_RESULT: (state, rst) => {
      state.state_AllInPayOrder_WechatGenerateOrderResult = rst;
    },
    SET_ALLINPAYORDER_WECHATPAYCALLBACK_RESULT: (state, rst) => {
      state.state_AllInPayOrder_WechatPayCallbackResult = rst;
    },
    SET_ALLINPAYORDER_GETMYPAYPAGE_RESULT: (state, rst) => {
      state.state_AllInPayOrder_GetMyPayPageResult = rst;
    },
  },
  actions: {
    AllInPayOrderServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ALLINPAYORDER_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ALLINPAYORDER_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AllInPayOrderServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ALLINPAYORDER_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ALLINPAYORDER_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AllInPayOrderServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ALLINPAYORDER_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ALLINPAYORDER_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AllInPayOrderServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ALLINPAYORDER_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ALLINPAYORDER_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AllInPayOrderServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ALLINPAYORDER_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ALLINPAYORDER_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AllInPayOrderServ_GetMyCreatePage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyCreatePage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ALLINPAYORDER_GETMYCREATEPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ALLINPAYORDER_GETMYCREATEPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AllInPayOrderServ_WechatGenerateOrder({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        wechatGenerateOrder(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ALLINPAYORDER_WECHATGENERATEORDER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ALLINPAYORDER_WECHATGENERATEORDER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AllInPayOrderServ_WechatPayCallback({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        wechatPayCallback(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ALLINPAYORDER_WECHATPAYCALLBACK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ALLINPAYORDER_WECHATPAYCALLBACK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AllInPayOrderServ_GetMyPayPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyPayPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ALLINPAYORDER_GETMYPAYPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ALLINPAYORDER_GETMYPAYPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_AllInPayOrder_GetDetailResult: state => {
      return state.state_AllInPayOrder_GetDetailResult;
    },
    get_AllInPayOrder_DeleteObjResult: state => {
      return state.state_AllInPayOrder_DeleteObjResult;
    },
    get_AllInPayOrder_SearchByNameResult: state => {
      return state.state_AllInPayOrder_SearchByNameResult;
    },
    get_AllInPayOrder_GetAllResult: state => {
      return state.state_AllInPayOrder_GetAllResult;
    },
    get_AllInPayOrder_GetPageResult: state => {
      return state.state_AllInPayOrder_GetPageResult;
    },
    get_AllInPayOrder_GetMyCreatePageResult: state => {
      return state.state_AllInPayOrder_GetMyCreatePageResult;
    },
    get_AllInPayOrder_WechatGenerateOrderResult: state => {
      return state.state_AllInPayOrder_WechatGenerateOrderResult;
    },
    get_AllInPayOrder_WechatPayCallbackResult: state => {
      return state.state_AllInPayOrder_WechatPayCallbackResult;
    },
    get_AllInPayOrder_GetMyPayPageResult: state => {
      return state.state_AllInPayOrder_GetMyPayPageResult;
    },
  }
}